const { fetchJsonApi } = require('./abstract');

function getGeoIpData(ip = '') {
  return fetchJsonApi({
    apiUrl: 'https://freegeoip.net/',
    method: 'GET',
    expectedStatus: 200,
    endpoint: `json/${ip}`,
    skipHumanVerification: true,
    description: 'Getting GeoIP data',
  });
}

function getGeoIpCountry(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'POST',
    endpoint: 'v1/country',
    expectedStatus: 200,
    description: 'Get country',
  });
}

module.exports = {
  getGeoIpData,
  getGeoIpCountry,
};
